import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const RoleCredentialsGuide = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const roles = [
    {
      role: 'Client',
      icon: 'User',
      email: 'client@plumberpro.fr',
      password: 'Client2025!',
      description: 'Accès au portail client pour réserver et suivre vos services',
      color: 'var(--color-primary)'
    },
    {
      role: 'Technicien',
      icon: 'Wrench',
      email: 'technicien@plumberpro.fr',
      password: 'Tech2025!',
      description: 'Gestion des interventions quotidiennes et parcours',
      color: 'var(--color-success)'
    },
    {
      role: 'Dispatch',
      icon: 'Radio',
      email: 'dispatch@plumberpro.fr',
      password: 'Dispatch2025!',
      mfa: true,
      description: 'Centre de contrôle pour la planification et le suivi',
      color: 'var(--color-warning)'
    },
    {
      role: 'Formateur',
      icon: 'BookOpen',
      email: 'formateur@plumberpro.fr',
      password: 'Trainer2025!',
      description: 'Gestion du catalogue et des standards de qualité',
      color: 'var(--color-accent)'
    },
    {
      role: 'Administrateur',
      icon: 'Settings',
      email: 'admin@plumberpro.fr',
      password: 'Admin2025!',
      mfa: true,
      description: 'Accès complet au système et aux analyses',
      color: 'var(--color-secondary)'
    }
  ];

  const copyToClipboard = (text) => {
    navigator.clipboard?.writeText(text);
  };

  return (
    <div className="bg-card rounded-lg shadow-md overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-6 py-4 flex items-center justify-between hover:bg-muted transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="Key" size={20} color="var(--color-accent)" />
          </div>
          <div className="text-left">
            <h3 className="text-sm font-semibold text-foreground">
              Identifiants de démonstration
            </h3>
            <p className="text-xs text-muted-foreground">
              Testez les différents rôles utilisateur
            </p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={20} 
          color="var(--color-muted-foreground)" 
        />
      </button>
      {isExpanded && (
        <div className="px-6 pb-6 space-y-4 border-t border-border">
          <div className="pt-4 space-y-3">
            {roles?.map((roleData, index) => (
              <div
                key={index}
                className="bg-muted rounded-lg p-4 space-y-3"
              >
                <div className="flex items-center gap-3">
                  <div 
                    className="w-10 h-10 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: `${roleData?.color}15` }}
                  >
                    <Icon name={roleData?.icon} size={20} color={roleData?.color} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <h4 className="text-sm font-semibold text-foreground">
                        {roleData?.role}
                      </h4>
                      {roleData?.mfa && (
                        <span className="px-2 py-0.5 bg-warning/10 text-warning text-xs font-medium rounded">
                          MFA: 123456
                        </span>
                      )}
                    </div>
                    <p className="text-xs text-muted-foreground mt-1">
                      {roleData?.description}
                    </p>
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-background rounded px-3 py-2">
                      <p className="text-xs text-muted-foreground mb-1">Email</p>
                      <p className="text-sm font-mono text-foreground">
                        {roleData?.email}
                      </p>
                    </div>
                    <button
                      onClick={() => copyToClipboard(roleData?.email)}
                      className="p-2 hover:bg-background rounded transition-colors"
                      aria-label="Copier l'email"
                    >
                      <Icon name="Copy" size={16} color="var(--color-muted-foreground)" />
                    </button>
                  </div>

                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-background rounded px-3 py-2">
                      <p className="text-xs text-muted-foreground mb-1">Mot de passe</p>
                      <p className="text-sm font-mono text-foreground">
                        {roleData?.password}
                      </p>
                    </div>
                    <button
                      onClick={() => copyToClipboard(roleData?.password)}
                      className="p-2 hover:bg-background rounded transition-colors"
                      aria-label="Copier le mot de passe"
                    >
                      <Icon name="Copy" size={16} color="var(--color-muted-foreground)" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-primary/5 border border-primary/20 rounded-lg p-3">
            <div className="flex items-start gap-2">
              <Icon name="AlertCircle" size={16} color="var(--color-primary)" />
              <p className="text-xs text-muted-foreground">
                Ces identifiants sont uniquement pour la démonstration. En production, utilisez vos propres identifiants sécurisés.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoleCredentialsGuide;